// extracted by mini-css-extract-plugin
export default {"wiseWrapper":"HtmlBlockMultipleArticle_wiseWrapper__LH+1U"};